// Says what the insights left out of a period as not meetings, from
// meetingCost[period][perspective].notCounted written by the nightly job:
// { entries, hours, byReason: { travel: 3, fromGmail: 2, ... } }.
const GROUPS = [
  { label: "travel", reasons: ["travel", "fromGmail"] },
  { label: "meals and social", reasons: ["meal_or_social"] },
  {
    label: "personal time and reminders",
    reasons: ["personal_block", "reminder", "outOfOffice", "focusTime", "workingLocation", "birthday"],
  },
  { label: "one-person entries", reasons: ["under_two_people"] },
];

export const notCountedNote = (notCounted) => {
  const byReason = notCounted?.byReason || {};
  const parts = GROUPS.map(({ label, reasons }) => ({
    label,
    count: reasons.reduce((sum, reason) => sum + (byReason[reason] || 0), 0),
  }))
    .filter((group) => group.count > 0)
    .map((group) => `${group.count} ${group.label}`);
  if (!parts.length) return null;
  return `Not counted as meetings: ${parts.join(", ")}.`;
};
